import { requestGet, requestPost } from '@/utils/request';

const api = {
	LIST: '/member/user_recharge_list',
	ADD: '/member/user_recharge_add',
};

export async function userRechargeList(queryParams) {
	return requestGet(api.LIST, queryParams);
}

export async function userRechargeAdd(form) {
	return requestPost(api.ADD, form);
}
